import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AddressArea } from '../../models/addressarea.interface';
import { ApiService } from '../api/api.service';

@Injectable()
export class AddressService {
    constructor(private apiService: ApiService) {}

    saveAddressArea(area: AddressArea) {
        return this.apiService.postCall$<AddressArea>(`address-area`, area);
    }

    getAddressAreas() {
        return this.apiService.getCall$<AddressArea[]>(`address-area`).pipe(
            map(response => {
                response.data = response.data?.map(area => this.parseExteriorRing(area));
                return response;
            })
        );
    }

    deleteAddressArea(id: number) {
        return this.apiService.deleteCall$(`address-area/${id}`);
    }

    getBuildings(points: any[]) {
        return this.apiService.postCall$<
            {
                identificatie: string;
                status: string;
                gebruiksdoelen: string[];
                locatie: {
                    lat: number;
                    lng: number;
                };
            }[]
        >(`address-area/buildings`, { points });
    }

    getAddresses(numbers: any[]) {
        return this.apiService.postCall$<{ id: string; line_one: string; line_two: string }[]>(
            `address-area/addresses`,
            { numbers }
        );
    }

    getAreaById(id: string) {
        return this.apiService.getCall$<AddressArea>(`address-area/${id}`).pipe(
            map(response => {
                response.data = this.parseExteriorRing(response.data);
                return response;
            })
        );
    }

    private parseExteriorRing(area: AddressArea): AddressArea {
        if (typeof area?.exteriorRing === 'string') {
            area.exteriorRing = JSON.parse(area.exteriorRing);
        }
        return area;
    }

    getAddressAreaPdf(id: number) {
        return this.apiService.getBlobCall(`pdf/addressarea/${id}`);
    }
}
